import { Dispatch } from "redux";
import {
  SET_Centre_DATA,
  GET_Centre,
  SET_Mapping_DATA,
  GET_Mapping,
} from "../../types/actions/Support.action";
import { fetchError, fetchStart, fetchSuccess } from "./Common";
import jwtAxios from "../../@crema/services/auth/jwt-auth";
import { AppActions } from "types";

// Centre Actions 
export const getCentre = (search: string, page: number) => {
  return (dispatch: Dispatch<AppActions>) => {
    dispatch(fetchStart());
    jwtAxios
      .get("/api/ecommerce/centre", {
        params: { search, page },
      })
      .then((data) => {
        if (data.status === 200) {
          dispatch(fetchSuccess());
          dispatch({ type: GET_Centre, payload: data.data });
        } else {
          dispatch(fetchError("Something went wrong, Please try again!"));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error.message));
      });
  };
};

export const getCentreDetail = (sNo: number | string) => {
  return (dispatch: Dispatch<AppActions>) => {
    dispatch(fetchStart());
    jwtAxios
      .get("/api/ecommerce/centre/get", {
        params: { sNo: sNo },
      })
      .then((data) => {
        if (data.status === 200) {
          dispatch(fetchSuccess());
          dispatch({ type: SET_Centre_DATA, payload: data.data });
        } else {
          dispatch(fetchError("Something went wrong, Please try again!"));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error.message));
      });
  };
};

// Mapping Actions 
export const getMapping = (search: string, page: number) => {
  return (dispatch: Dispatch<AppActions>) => {
    dispatch(fetchStart());
    jwtAxios
      .get("/api/ecommerce/mapping", {
        params: { search, page },
      })
      .then((data) => {
        if (data.status === 200) {
          dispatch(fetchSuccess());
          dispatch({ type: GET_Mapping, payload: data.data });
        } else {
          dispatch(fetchError("Something went wrong, Please try again!"));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error.message));
      });
  };
};

export const getMappingDetail = (sNo: number | string) => {
  return (dispatch: Dispatch<AppActions>) => {
    dispatch(fetchStart());
    jwtAxios
      .get("/api/ecommerce/mapping/get", {
        params: { sNo: sNo },
      })
      .then((data) => {
        if (data.status === 200) {
          dispatch(fetchSuccess());
          dispatch({ type: SET_Mapping_DATA, payload: data.data });
        } else {
          dispatch(fetchError("Something went wrong, Please try again!"));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error.message));
      });
  };
};
